import { ButtonGroup, Button, Popper, Grow, Paper, ClickAwayListener, MenuList, MenuItem } from '@mui/material';
import React from 'react';
import { CompanyContactDataRoom, DataRoomContact } from '../../../shared/models';
import { DataRoom } from '../../../shared/models/DataRoom';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface BorrowerParticipantActionButtonProps {
	isEmployee: boolean;
	isCompanyUser: boolean;
	isBanker: boolean;
	dataRoom: DataRoom;
	contact: CompanyContactDataRoom;
	edit: (contact: CompanyContactDataRoom) => void;
	sendAccountInfo: (contact: CompanyContactDataRoom) => void;
}

type BorrowerParticipantActionItem = keyof typeof BorrowerParticipantActionItemMap;
const BorrowerParticipantActionItemMap = {
	Edit: 'Edit',
	SendAccountInfo: 'Send Account Info',
};

export const BorrowerParticipantActionButton: React.FC<BorrowerParticipantActionButtonProps> = ({
	dataRoom,
	contact,
	edit,
	sendAccountInfo,
}) => {
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef<HTMLDivElement>(null);
	const isRoomOpen = dataRoom.roomStatus == 'Open';

	const handleToggle = () => {
		setOpen(prevOpen => !prevOpen);
	};

	const handleClick = (action: BorrowerParticipantActionItem) => {
		switch (action) {
			case 'Edit':
				edit(contact);
				break;
			case 'SendAccountInfo':
				sendAccountInfo(contact);
				break;
		}
	};

	const handleClose = (event: Event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
			return;
		}

		setOpen(false);
	};

	const handleMenuItemClick = (
		event: React.MouseEvent<HTMLLIElement, MouseEvent>,
		actionItem: BorrowerParticipantActionItem
	) => {
		setOpen(false);
		handleClick(actionItem);
	};

	return (
		<>
			<ButtonGroup variant="contained" ref={anchorRef} aria-label="split button">
				<Button onClick={handleToggle}>Actions</Button>
				<Button
					size="small"
					aria-controls={open ? 'split-button-menu' : undefined}
					aria-expanded={open ? 'true' : undefined}
					aria-label="select merge strategy"
					aria-haspopup="menu"
					onClick={handleToggle}
				>
					<ArrowDropDownIcon />
				</Button>
			</ButtonGroup>
			<Popper
				open={open}
				style={{ zIndex: 1000, margin: 0 }}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
						}}
					>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList autoFocusItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'Edit')}>
										{BorrowerParticipantActionItemMap['Edit']}
									</MenuItem>

									<MenuItem onClick={event => handleMenuItemClick(event, 'SendAccountInfo')}>
										{BorrowerParticipantActionItemMap['SendAccountInfo']}
									</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</>
	);
};
